export const USER_NOTIFICATION_LEVEL_KEYS = [
  'suspectedFailure',
  'lowBeltContact',
  'aiTemperatureAnomaly',
  'gatewayInactive',
  'highSpeed',
  'bTempA',
  'bTempB',
];

export const getSupportedLevels = (levels) => (
  (levels ?? []).filter((level) => USER_NOTIFICATION_LEVEL_KEYS.includes(level))
);
